import MenuForm from '../../components/Menu/MenuForm'

export default function MenuEdit() {
  return <MenuForm />
}
